export const version = "abstract-signer/1.2.3";
